import classNames from 'classnames';
import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import { marked } from 'marked';
import markedLinkifyIt from 'marked-linkify-it';
import { memo, useEffect, useRef } from 'react';

import type { ReactClassNameInterface } from '@/types/common';
import { EVENT } from '@/utils/event';
import { formatDuration } from '@/utils/timestamp-format';

import styles from './index.less';

export interface IProps extends ReactClassNameInterface {
  content?: string;
  id?: string;
}

dayjs.extend(durationPlugin);

const renderer = new marked.Renderer();

// 使用定制的渲染器解析 markdown
marked.setOptions({ renderer });
marked.use(markedLinkifyIt());

function SimplyMD(props: IProps) {
  const { className, content, style } = props;
  const markdownRef = useRef<HTMLDivElement>(null);

  const handleClickTimestamp = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const timestamp = (e.target as HTMLSpanElement).dataset.timestamp;

    dispatchEvent(new CustomEvent(EVENT.SEEK_AUDIO_TIMESTAMP, { detail: { timestamp } }));
  };

  useEffect(() => {
    // 覆盖默认的链接渲染函数，给时间戳用
    renderer.link = function (href, title, text) {
      if (
        text === '<em>TIMESTAMP</em>' ||
        text === '_TIMESTAMP_' ||
        text === '<em><fade-in-text>TIMESTAMP</fade-in-text></em>'
      ) {
        const dates = href.replace(/[{}']/g, '').split('-');

        return `<span id='_TIMESTAMP_' style="color:#7B67EF;cursor:pointer" data-timestamp="${Number(
          dates[0]
        )}">🔊${formatDuration(Number(dates[0] || 0) * 1000)}</span>`;
      }

      // 对于非定制需求，使用默认的链接渲染
      return `<a href="${href}" title="${title}">${text}</a>`;
    };

    if (markdownRef.current) {
      markdownRef.current.innerHTML = marked.parse(content ?? '');

      markdownRef.current.innerHTML = markdownRef.current.innerHTML
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');

      const timestamp = document.querySelectorAll('#_TIMESTAMP_');

      timestamp.forEach((item) => {
        item.addEventListener('click', handleClickTimestamp);
      });
    }
  }, [content]);

  return (
    <div className={styles.markdown}>
      <div
        ref={markdownRef}
        className={classNames(styles.container, className, 'relative')}
        style={style}
      />
    </div>
  );
}

export default memo(SimplyMD);
